import React from "react";
import QRCode from "react-qr-code";

/** Builds the wallet URI for the selected coin (landing demo QR).
 * Bare address for account-based chains — matches lib/coins.js uriFor. */
export function buildWalletUri(coin, address) {
  if (!address) return "";
  const c = coin.toLowerCase();
  if (c === "btc") return `bitcoin:${address}`;
  return address;
}

/**
 * WalletQR — renders a QR on a white tile so it stays scannable on dark
 * surfaces. The wrapper keeps a thin mint border for brand cohesion.
 */
export default function WalletQR({ value, size = 200, testId = "wallet-qr" }) {
  if (!value) {
    return (
      <div
        data-testid={`${testId}-empty`}
        className="flex items-center justify-center border border-dashed border-zinc-700 rounded-md text-xs text-zinc-500 mono bg-zinc-900/50"
        style={{ width: size, height: size }}
      >
        no address set
      </div>
    );
  }
  return (
    <div
      data-testid={testId}
      role="img"
      aria-label={`payment QR code — scan with your wallet app to pay ${value.length > 60 ? value.slice(0, 60) + "…" : value}`}
      className="p-3 bg-white rounded-md border border-mint/30"
      style={{ width: size + 24, height: size + 24 }}
    >
      <QRCode value={value} size={size} bgColor="#FFFFFF" fgColor="#000000" aria-hidden="true" />
    </div>
  );
}
